import moment from 'moment';

export const subtractWeekdaysMoment = (ymd, days) => {
    let m = moment(ymd, "YYYY-MM-DD"); // parse as local date
    let remaining = days;

    while (remaining > 0) {
    m = m.subtract(1, "day");
    const day = m.day(); // 0=Sunday … 6=Saturday
    if (day !== 0 && day !== 6) remaining--;
    }
    return m.format("YYYY-MM-DD");
}

export const addWeekdaysMoment = (ymd, days) => {
    let m = moment(ymd, "YYYY-MM-DD"); // parse as local date
    let remaining = days;

    while (remaining > 0) {
    m = m.add(1, "day");
    const day = m.day(); // 0 = Sunday … 6 = Saturday
    if (day !== 0 && day !== 6) remaining--;
    }
    return m.format("YYYY-MM-DD");
}

export default {
    addWeekdaysMoment,
    subtractWeekdaysMoment
};